import Vue from "vue";
import VueRouter from "vue-router";

// 注册 vue-router（需在 VueRouter 实例创建之前调用）
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 引入组件 HomeView
import HomeView from "../views/home/index.vue";//首页
import newsroom from "../views/news/index.vue";//新闻
import careers from "../views/careers/index.vue";
import insight from "../views/insight/index.vue";
import podcasts from "../views/insight/podcasts.vue";
import blogs from "../views/insight/blogs.vue";
import people from "../views/people/index.vue";
import aboutus from "../views/aboutus/index.vue";
import expertiseArticel from "../views/expertise/articel.vue";
import locations from "../views/locations/index.vue";

// 设置路由规则
const routes = [{
		path: "/", // 设置路由路径
		name: "home", // 设置组件名称（可选）
		component: HomeView, // 注册组件
	},
	{
		path: "/newsroom", // 设置路由路径
		name: "newsroom", // 设置组件名称（可选）
		component: newsroom, // 注册组件
	},
	{
		path: "/careers", // 设置路由路径
		name: "careers", // 设置组件名称（可选）
		component: careers, // 注册组件
	},
	{
		path: "/insight", // 设置路由路径
		name: "insight", // 设置组件名称（可选）
		component: insight, // 注册组件
	},
	{
		path: "/insight/podcasts", // 设置路由路径
		name: "podcasts", // 设置组件名称（可选）
		component: podcasts, // 注册组件
	},
	{
		path: "/insight/blogs", // 设置路由路径
		name: "blogs", // 设置组件名称（可选）
		component: blogs, // 注册组件
	},
	{
		path: "/people", // 设置路由路径
		name: "people", // 设置组件名称（可选）
		component: people, // 注册组件
	},
	{
		path: "/aboutus", // 设置路由路径
		name: "aboutus", // 设置组件名称（可选）
		component: aboutus, // 注册组件
	},
	{
		path: "/expertise/articel", // 设置路由路径
		name: "expertiseArticel", // 设置组件名称（可选）
		component: expertiseArticel, // 注册组件
	},
	{
		path: "/locations", // 设置路由路径
		name: "locations", // 设置组件名称（可选）
		component: locations, // 注册组件
	}
];

const router = new VueRouter({
	mode: 'hash',
	routes,
	scrollBehavior(to,from,savePosition) {
		return {x:0,y:0};
	}
}); // 创建 VueRouter 实例

export default router; // 导出 VueRouter 实例
